import React from 'react';

import { Badge } from '@/components/global/Badge';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';

type TProps = {
  data: TRecommendation;
};

export function ExpiredIn({ data }: TProps) {
  return (
    <Badge
      className="vitrine-template4__expired-in"
      text={data.validity}
      variant="neutral"
    />
  );
}
